var wrapperElement, subColumnElement, headerNavDrawerElement;
var spsDrawerOpenClass = 'spsDrawerOpen';
var spsDrawerCloseClass = 'spsDrawerClose';

window.onload = function() {
  headerNavDrawerElement = document.getElementById('header-nav-drawer');
  wrapperElement = document.getElementById('wrapper');
  subColumnElement = document.getElementById('sub-column');

  hideSidebar();

  if (headerNavDrawerElement && subColumnElement) {
    headerNavDrawerElement.addEventListener('click', function(e) {
      toggleDisplaySidebar();
    });
  }
}

function toggleDisplaySidebar() {
  if (isSidebarShown()) {
    hideSidebar();
  } else {
    showSidebar();
  }
}

function isSidebarShown() {
  if (subColumnElement) {
    return subColumnElement.className === spsDrawerOpenClass;
  }

  return 0;
}

function showSidebar() {
  if (subColumnElement) {
    subColumnElement.className = spsDrawerOpenClass;
  }

  if (wrapperElement) {
    wrapperElement.className = spsDrawerOpenClass;
  }

  if (headerNavDrawerElement) {
    headerNavDrawerElement.className = spsDrawerOpenClass;
  }

  window.addEventListener('click', handleOutsideDrawer);
  window.addEventListener('touchstart', handleOutsideDrawer, {passive: false});
}

function hideSidebar() {
  if (subColumnElement) {
    subColumnElement.className = spsDrawerCloseClass;
  }

  if (wrapperElement) {
    wrapperElement.className = spsDrawerCloseClass;
  }

  if (headerNavDrawerElement) {
    headerNavDrawerElement.className = spsDrawerCloseClass;
  }

  window.removeEventListener('click', handleOutsideDrawer);
  window.removeEventListener('touchstart', handleOutsideDrawer, {passive: false});
}

function handleOutsideDrawer(e) {
  if (!subColumnElement.contains(e.target) &&
      !headerNavDrawerElement.contains(e.target) &&
      !(e.target.className === 'prev' || e.target.className === 'next')) {
    hideSidebar();
    e.preventDefault();
  }
}